// extracted by mini-css-extract-plugin
export default {"planList":"PlanList_planList__Hz0hi"};